import Button from "../../../components/Button/Button";
import styled from "styled-components";

type ConfirmModalProps = {
  isOpen: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm(): void;
  onCancel(): void;
};

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalCard = styled.div`
  width: 520px;
  max-width: calc(100vw - 2rem);
  background: ${({ theme }) => theme.colorBackgroundLight};
  border: 1px solid ${({ theme }) => theme.colorBorderLight};
  border-radius: 8px;
  padding: 1rem;
`;

const ModalTitle = styled.h3`
  margin: 0 0 0.5rem 0;
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
`;

function ConfirmModal({
  isOpen,
  title = "Confirm",
  message,
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <Backdrop
      onClick={() => {
        onCancel();
      }}
    >
      <ModalCard
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ModalTitle>{title}</ModalTitle>
        <p className="opacity-80">{message}</p>

        <ModalActions>
          <Button onClick={onCancel}>{cancelText}</Button>
          <Button onClick={onConfirm}>{confirmText}</Button>
        </ModalActions>
      </ModalCard>
    </Backdrop>
  );
}

export default ConfirmModal;
